






























































































































import {
  BSidebar,
  BForm,
  BButton,
  BCard,
  BCol,
  BFormCheckbox,
  BDropdown,
  BFormGroup,
  BDropdownItem,
  BFormInput,
  BPagination,
  BFormSelect,
  BRow,
  BTable,
  BSpinner,
} from "bootstrap-vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { CreateProcessusModel } from "@/api/models/fichesIncident/processus";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import { PaginatedList } from "@/api/models/common/paginatedList";
import { ShortEquipe } from "@/api/models/options/equipes/equipe";
import { MembreEquipe } from "@/api/models/membreEquipes/membreEquipes";
import { DetailsUtilisateur } from "@/api/models/utilisateurs/utilisateur";

@Component({
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BTable,
    BPagination,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BSidebar,
    BForm,
    BFormGroup,
    BFormCheckbox,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    SearchableVueSelect,
  },
  name: "create-processus",
})
export default class CreateProcessus extends Vue {
  @Prop({ required: true, type: Boolean })
  isAddNewProcessusSidebarActive!: boolean;
  loading = false;

  required = required;

  newProcessus: CreateProcessusModel = {
    nom: "",
    piloteId: "",
    membresId: []
  };

  listPilotes: any[] = [];
  totalCountPilotes = 0;
  
  listMembres: any[] = [];
  totalCountMembres = 0;

  async searchPilotes(params: any) {
    await this.$http.myressif.utilisateurs
    .paginatedList(
        params?.pageNumber ?? 1,
        params?.pageSize ?? 10,
        params?.search ?? "",
        false,
        "Nom",
        false
      )
      .then((response: PaginatedList<DetailsUtilisateur>) => {
        this.listPilotes = this.listPilotes!.concat(
            response.items.filter(
              (ri) => !this.listPilotes!.some((lsi) => lsi.id == ri.id)
            )
          ).map((x: DetailsUtilisateur) => <DetailsUtilisateur>{
          ...x,
          completeLabel: `${x.nom} ${x.prenom}`
        });
        this.totalCountPilotes = response.totalCount
        }
      )
  }

  
  async searchMembres(params: any) {
    await this.$http.myressif.utilisateurs
    .paginatedList(
        params?.pageNumber ?? 1,
        params?.pageSize ?? 10,
        params?.search ?? "",
        false,
        "Nom",
        false
      )
      .then((response: PaginatedList<DetailsUtilisateur>) => {
        this.listMembres = this.listMembres!.concat(
            response.items.filter(
              (ri) => !this.listMembres!.some((lsi) => lsi.id == ri.id)
            )
          ).map((x: DetailsUtilisateur) => <DetailsUtilisateur>{
          ...x,
          completeLabel: `${x.nom} ${x.prenom}`
        });
        this.totalCountMembres = response.totalCount
        }
      )
  }
  resetForm() {
    this.newProcessus = {
      nom: "",
      piloteId: "",
      membresId: []
    };
  }

  async submit() {
    this.loading = true;
    await this.$http.myressif.processus
      .post(this.newProcessus)
      .then(
        async (response: any) => {
          successAlert.fire({
            timer: 3500,
            title: "Création d'un processus",
            text: "Processus créé avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.$emit("refresh-processus");
        this.$emit("update:is-add-new-processus-sidebar-active", false);
        this.loading = false;
      });
  }
}
